module.exports = require("os");


//////////////////
// WEBPACK FOOTER
// external "os"
// module id = 129
// module chunks = 0 1